import { HubFeature } from '@ats/api/cm';
import { LocDefs, LocMap, LocPortal, MapLocKeys } from '@cm/core/localization';

export type SPBenefitTokenInvalidateModalLocs =
	| 'SPBenefitTokenInvalidateModalTitle'
	| 'SPBenefitTokenInvalidateModalLabelBatchId'
	| 'SPBenefitTokenInvalidateModalLabelReassign'
	| 'SPBenefitTokenInvalidateModalHintReassign'
	| 'SPBenefitTokenInvalidateModalButtonCancel'
	| 'SPBenefitTokenInvalidateModalButtonSubmit'
	| 'SPBenefitTokenInvalidateModalNotificationSuccess';

export const spBenefitTokenInvalidateModalLocs: LocDefs<SPBenefitTokenInvalidateModalLocs> = {
	SPBenefitTokenInvalidateModalTitle: {
		defaultValue: 'Invalidate Batch Tokens',
		description: 'Title for the invalidate batch tokens modal',
		displayPath: 'Catalogs|Benefit|Tokens|Invalidate|Title|InvalidateModal',
		displayType: 'Title',
		feature: HubFeature.Benefit,
		legacyName: 'Benefit/Catalogs.BenefitTokens.Invalidate.Title.InvalidateModal',
		portal: 'SP' as LocPortal,
	},
	SPBenefitTokenInvalidateModalLabelBatchId: {
		defaultValue: 'Batch ID',
		description: 'Label for displaying the batch ID in invalidate modal',
		displayPath: 'Catalogs|Benefit|Tokens|BatchID',
		displayType: 'Label',
		feature: HubFeature.Benefit,
		legacyName: 'Benefit/Catalogs.BenefitTokens.FieldLabel.BatchID',
		portal: 'SP' as LocPortal,
	},
	SPBenefitTokenInvalidateModalLabelReassign: {
		defaultValue: 'Reassign Existing Tokens',
		description: 'Label for the reassign existing tokens checkbox',
		displayPath: 'Catalogs|Benefit|Tokens|Invalidate|ReassignExisting',
		displayType: 'Label',
		feature: HubFeature.Benefit,
		legacyName: 'Benefit/Catalogs.BenefitTokens.Invalidate.FieldLabel.ReassignExisting',
		portal: 'SP' as LocPortal,
	},
	SPBenefitTokenInvalidateModalHintReassign: {
		defaultValue: `<p>Warning! If this is not checked, candidates who have a current Individual Token
      will no longer be able to use their benefit.</p>
      <p>If this is checked, the system will make sure there are enough existing
      Individual Tokens and reassign any candidates that have the invalidated Individual Token with a new, valid one.</p>`,
		description: 'Help text explaining the reassign existing tokens option',
		displayPath: 'Catalogs|Benefit|Tokens|Invalidate|Field Hint|ReassignExisting',
		displayType: 'Content',
		feature: HubFeature.Benefit,
		legacyName: 'Benefit/Catalogs.BenefitTokens.Invalidate.FieldHint.ReassignExisting',
		portal: 'SP' as LocPortal,
		htmlAllowed: true,
	},
	SPBenefitTokenInvalidateModalButtonCancel: {
		defaultValue: 'Cancel',
		description: 'Button text to cancel the invalidation process',
		displayPath: 'Catalogs|Benefit|Tokens|Invalidate Cancel',
		displayType: 'Button',
		feature: HubFeature.Benefit,
		legacyName: 'Benefit/Catalogs.BenefitTokens.Invalidate.Button.Cancel',
		portal: 'SP' as LocPortal,
	},
	SPBenefitTokenInvalidateModalButtonSubmit: {
		defaultValue: 'Invalidate Batch Tokens',
		description: 'Button text to submit the invalidation process',
		displayPath: 'Catalogs|Benefit|Tokens|Invalidate Submit',
		displayType: 'Button',
		feature: HubFeature.Benefit,
		legacyName: 'Benefit/Catalogs.BenefitTokens.Invalidate.Button.Submit',
		portal: 'SP' as LocPortal,
	},
	SPBenefitTokenInvalidateModalNotificationSuccess: {
		defaultValue: 'Successfully invalidated token',
		description: 'Notification message for successful token invalidation',
		displayPath: 'Catalogs|Benefit|Tokens|Invalidate Success',
		displayType: 'Notification',
		feature: HubFeature.Benefit,
		legacyName: 'Benefit/Catalogs.BenefitTokens.NotificationMessage.InvalidateSuccess',
		portal: 'SP' as LocPortal,
	},
};

export const LOC_KEYS = MapLocKeys<SPBenefitTokenInvalidateModalLocs>(
	spBenefitTokenInvalidateModalLocs
);
export type SpBenefitTokenInvalidateModalLocKeys = LocMap<SPBenefitTokenInvalidateModalLocs>;
